<div class="container-fluid sell_dash">
    <div class="wrapper">
        <div class="row">
          <app-sidemenu></app-sidemenu> 
          <section class="right">
              <app-sellheader></app-sellheader>
              <div class="right-middle row justify-content-center">
              <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">

                        <!--begin::Portlet-->
                        <div class="kt-portlet">
                            <div class="kt-portlet__body kt-portlet__body--fit">

                                <!--begin::Basic Pricing 4-->
                                <div class="kt-pricing-4">
                                    <div class="kt-pricing-4__top">
                                        <div class="kt-pricing-4__top-container kt-pricing-4__top-container--fixed">
                                            <div class="kt-pricing-4__top-header">
                                                <div class="kt-pricing-4__top-title kt-font-light">
                                                    <h1>Transparent & Simple Pricing</h1>
                                                </div>
                                            </div>
                                            <div class="kt-pricing-4__top-body">

                                                <!--begin::Pricing Items-->
                                                <div class="kt-pricing-4__top-items">

                                                    <!--begin::Pricing Item-->
                                                    <div class="kt-pricing-4__top-item">
                                                        <span class="kt-pricing-4__icon kt-font-info">
                                                            <i class="fa flaticon-rocket"></i>
                                                        </span>
                                                        <h2 class="kt-pricing-4__subtitle">Basic Plan</h2>
                                                        <div class="kt-pricing-4__features">
                                                            <span>Lorem ipsum dolor adipiscing</span><br>
                                                            <span>do eiusmod tempors</span>
                                                        </div>
                                                        <span class="kt-pricing-4__price">69</span>
                                                        <span class="kt-pricing-4__label">$</span>
                                                        <div class="kt-pricing-4__btn">
                                                            <button type="button" class="btn btn-pill btn-info btn-upper btn-bold">Purchase</button>
                                                        </div>

                                                        <!--begin::Mobile Pricing Table-->
                                                        <div class="kt-pricing-4__top-items-mobile">
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Number Of Users</span>
                                                                <span>Up to 10k</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Domains</span>
                                                                <span>1</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Projects</span>
                                                                <span>5</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Storage</span>
                                                                <span>5GB</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Supporet</span>
                                                                <span>No</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Tutorials</span>
                                                                <span>No</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Cancelation</span>
                                                                <span>Yes</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-btn">
                                                                <button type="button" class="btn btn-pill  btn-info btn-upper btn-bold">Purchase</button>
                                                            </div>
                                                        </div>

                                                        <!--end::Mobile Pricing Table-->
                                                    </div>

                                                    <!--end::Pricing Items-->

                                                    <!--begin::Pricing Items-->
                                                    <div class="kt-pricing-4__top-item">
                                                        <span class="kt-pricing-4__icon kt-font-info">
                                                            <i class="fa flaticon-confetti"></i>
                                                        </span>
                                                        <h2 class="kt-pricing-4__subtitle">For Business</h2>
                                                        <div class="kt-pricing-4__features">
                                                            <span>Lorem ipsum dolor adipiscing</span><br>
                                                            <span>do eiusmod tempors</span>
                                                        </div>
                                                        <span class="kt-pricing-4__price">169</span>
                                                        <span class="kt-pricing-4__label">$</span>
                                                        <div class="kt-pricing-4__btn">
                                                            <button type="button" class="btn btn-pill  btn-info btn-upper btn-bold">Purchase</button>
                                                        </div>

                                                        <!--begin::Mobile Pricing Table-->
                                                        <div class="kt-pricing-4__top-items-mobile">
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Number Of Users</span>
                                                                <span>Up to 100k</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Domains</span>
                                                                <span>20</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Projects</span>
                                                                <span>100</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Storage</span>
                                                                <span>200GB</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Supporet</span>
                                                                <span>Yes</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Tutorials</span>
                                                                <span>Yes</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Cancelation</span>
                                                                <span>Yes</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-btn">
                                                                <button type="button" class="btn btn-pill  btn-info btn-upper btn-bold">Purchase</button>
                                                            </div>
                                                        </div>

                                                        <!--end::Mobile Pricing Table-->
                                                    </div>

                                                    <!--end::Pricing Items-->

                                                    <!--begin::Pricing Items-->
                                                    <div class="kt-pricing-4__top-item">
                                                        <span class="kt-pricing-4__icon kt-font-info">
                                                            <i class="fa flaticon-gift"></i>
                                                        </span>
                                                        <h2 class="kt-pricing-4__subtitle">Enterprise</h2>
                                                        <div class="kt-pricing-4__features">
                                                            <span>Lorem ipsum dolor adipiscing</span><br>
                                                            <span>do eiusmod tempors</span>
                                                        </div>
                                                        <span class="kt-pricing-4__price">669</span>
                                                        <span class="kt-pricing-4__label">$</span>
                                                        <div class="kt-pricing-4__btn">
                                                            <button type="button" class="btn btn-pill  btn-info btn-upper btn-bold">Purchase</button>
                                                        </div>

                                                        <!--begin::Mobile Pricing Table-->
                                                        <div class="kt-pricing-4__top-items-mobile">
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Number Of Users</span>
                                                                <span>Unlimited</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Domains</span>
                                                                <span>100</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Projects</span>
                                                                <span>500</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Storage</span>
                                                                <span>Unlimited</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Supporet</span>
                                                                <span>Yes</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Tutorials</span>
                                                                <span>Yes</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-item-mobile">
                                                                <span>Cancelation</span>
                                                                <span>Yes</span>
                                                            </div>
                                                            <div class="kt-pricing-4__top-btn">
                                                                <button type="button" class="btn btn-pill  btn-info btn-upper btn-bold">Purchase</button>
                                                            </div>
                                                        </div>

                                                        <!--end::Mobile Pricing Table-->
                                                    </div>

                                                    <!--end::Pricing Items-->
                                                </div>

                                                <!--end::Pricing Items-->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kt-pricing-4__bottom">
                                        <div class="kt-pricing-4__bottok-container kt-pricing-4__bottok-container--fixed">
                                            <div class="kt-pricing-4__bottom-items">
                                                <div class="kt-pricing-4__bottom-item">
                                                    Number Of Users
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Up to 10k
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Up to 100k
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Unlimited
                                                </div>
                                            </div>
                                            <div class="kt-pricing-4__bottom-items">
                                                <div class="kt-pricing-4__bottom-item">
                                                    Domains
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    1
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    20
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    100
                                                </div>
                                            </div>
                                            <div class="kt-pricing-4__bottom-items">
                                                <div class="kt-pricing-4__bottom-item">
                                                    Projects
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    5
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    100
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    500
                                                </div>
                                            </div>
                                            <div class="kt-pricing-4__bottom-items">
                                                <div class="kt-pricing-4__bottom-item">
                                                    Storage
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    5GB
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    200GB
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Unlimited
                                                </div>
                                            </div>
                                            <div class="kt-pricing-4__bottom-items">
                                                <div class="kt-pricing-4__bottom-item">
                                                    Supporet
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    No
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Yes
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Yes
                                                </div>
                                            </div>
                                            <div class="kt-pricing-4__bottom-items">
                                                <div class="kt-pricing-4__bottom-item">
                                                    Tutorials
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    No
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Yes
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Yes
                                                </div>
                                            </div>
                                            <div class="kt-pricing-4__bottom-items">
                                                <div class="kt-pricing-4__bottom-item">
                                                    Cancelation
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Yes
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Yes
                                                </div>
                                                <div class="kt-pricing-4__bottom-item">
                                                    Yes
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--end::Basic Pricing 4-->
                            </div>
                        </div>

                        <!--end::Portlet-->
                    </div>
          </div>
        </section>
          <!-- begin::Sticky Toolbar -->
           <app-stickytoolbar></app-stickytoolbar>
          <!-- end::Sticky Toolbar -->       
     </div>
   </div>
</div>

